export default __webpack_public_path__ + "static/sam42_design-1b4d9ad61ed96436da5ba9a73f52bab8.jpg";